export default "__VITE_ASSET___vE_rMYi__"